//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// @ts-nocheck
import get from 'lodash/get'
import debounce from 'lodash/debounce'
import unionBy from 'lodash/unionBy'
import hasArticles from '~/mixins/hasArticles'
import hasWindow from '~/mixins/hasWindow'
// import Role from '~/models/Role'

import IconArticle from '~/assets/svg/article.svg?inline'
import Article from '~/models/Article'

export default {
  components: { IconArticle },

  mixins: [hasArticles, hasWindow],
  props: {
    linkToArticle: { type: Boolean, default: true },
    params: { type: Object, default: () => ({}) },
    showLoadMore: { type: Boolean, default: false },
    title: { type: String, default: null },
  },
  async fetch() {
    // const page = (this.lastMeta && this.lastMeta.current_page + 1) || 1
    // const params = { ...this.params, page }
  },

  data() {
    // return {
    //   didLoad: false, isLoading: false, lastMeta: null , mountains: [],}

    return this.getInitialData()
  },

  computed: {
    defaultTitle() {
      // if (this.$auth.user) {
      //   switch (this.$auth.user.role.code) {
      //     case Role.ROLE_GIRL:
      //       return 'Artikel untuk Girls'
      //     case Role.ROLE_PARENT:
      //       return 'Artikel untuk Orang Tua'
      //   }
      // }

      return 'Artikel'
    },
  },

  watch: {
    params() {
      this.refreshDebounced()
    },
  },

  beforeMount() {
    this.refreshDebounced = debounce(this.refresh, 200)
    this.refreshDebounced()
  },

  methods: {
    getInitialData() {
      return { didLoad: false, isLoading: false, lastMeta: null, articles: [] }
    },

    async loadMore() {
      if (
        this.lastMeta &&
        this.lastMeta.current_page === this.lastMeta.last_page
      ) {
        return
      }

      try {
        this.isLoading = true
        const page = (this.lastMeta && this.lastMeta.current_page + 1) || 1
        const params = { ...this.params, page }

        const response = await this.$axios.get(`v1/articles`, {
          params,
        })

        const articles = response.data.data.map(
          (article) => new Article(article)
        )

        this.articles = unionBy(this.articles, articles, ({ id }) => id)
        this.lastMeta = get(response.data, 'meta')
      } finally {
        this.isLoading = false
        this.didLoad = true
      }
    },

    /**
     * Refresh data.
     */
    refresh() {
      Object.assign(this, this.getInitialData())
      this.loadMore()
    },
  },
}
